import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import DeviceListRequest, {
  DeviceDetailRequest,
} from '../models/requests/GetDevice';
import Device, { DeviceDetail } from '../models/data/Device';

// 機器情報の取得関数
export default function requestDeviceList(
  url: string,
  params?: DeviceListRequest,
): Promise<AxiosResponse<Device[]>> {
  const config = createRequestConfig({ params });
  return axios.get<Device[]>(url, config);
}

// 機器情報件数の取得関数
export function requestCountDevice(
  url: string,
  params?: DeviceListRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 機器の詳細情報の取得関数
export function requestDeviceDetail(
  url: string,
  params?: DeviceDetailRequest,
): Promise<AxiosResponse<DeviceDetail>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceDetail>(url, config);
}
